var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#606060;}\r\n\t.st2{fill:#FFFFFF;stroke:#606060;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;stroke:#606060;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,504.5c-133.9,0-242.7-108.9-242.7-242.7C16.7,127.9,125.6,19,259.5,19c133.9,0,242.8,108.9,242.8,242.8 C502.2,395.6,393.3,504.5,259.5,504.5 M259.5,23.7c-131.3,0-238.1,106.8-238.1,238.1c0,131.3,106.8,238,238.1,238 c131.3,0,238.1-106.8,238.1-238C497.6,130.5,390.8,23.7,259.5,23.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "103.3,282.2 77.5,282.2 77.5,314.1 54.4,314.1 54.4,335.1 32,335.1 37.4,355.5 40.1,359.6  102.6,356.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.5,300.1l11,0.1c0,0-8.1-56.7-33.5-85.1l-21.4-7.7C376,212.1,416.2,255.6,415.5,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.1,200.5l-19.1-6.8c6.1,6.8,48.2,55.8,48,106l14.6,0.2c0.7-49.7-43.6-98.3-44-98.8L352.1,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.5,300.1c0.7-46.4-43.6-91.9-44-92.4l0.5-0.5l-18.5-6.6c3.5,4,44.7,51.1,44,99.3L414.5,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.4,193.6l0.4-0.4l-27.5-9.8c0,0,30.6,44,45.3,115.9l30.2,0.4C380.1,246.3,331.9,194.1,331.4,193.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.6,128.4c4.8-1.9,6.9-11.8,6.9-11.8c-1.4-0.4-4-3.9-4-3.9c-1.8-7.2-6.2-8.8-6.2-8.8h-0.1 c0,0-4.2,2-5.6,9.3c0,0-2.3,3.7-3.7,4.2c0,0,2.1,7.5,5.9,10.4l-0.3,18.8c-9.3,10.4-9,24.2-8.9,24.8c0.1,2.2,1.9,4,4.2,3.9 c2.2-0.1,4-1.9,3.9-4.2c0-0.1-0.1-8,4.1-15.2c1.7,3.2,3.5,8,3.7,14.2c0,0.3,0,0.7,0,1c0,0,0,0.1,0,0.1c0.1,2.2,1.9,4,4.1,4 c2.3,0,4.1-1.9,4.1-4.1c-0.1-14.2-7-23.1-8.4-24.8L236.6,128.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "279.9,177.1 279.9,55.8 354.1,55.8 372.2,66.6 372.2,183.4 279.9,187.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4,187.6V55.3h74.9l18.5,11.1v117.5L279.4,187.6z M280.3,56.2v130.3l91.4-3.6v-116L354,56.2H280.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "372.2,121 420.9,121 432.9,129.1 432.9,187.9 373.1,184.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,188.4l-0.5,0l-60.2-3.4l0-0.4l-0.9-64.1h49.3l12.3,8.3V188.4z M373.6,184.1l58.8,3.3v-58.1l-11.6-7.9h-48.1 L373.6,184.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.5,355.9H356.3l0.1-0.5c0-0.4,3.7-37.3-5.4-76.5c-8.4-36.1-29.8-81.6-83.8-93.2l0.1-1l160.4-4.5l0.1,0.1 l51.9,29.1V355.9z M357.4,355h121.2V210l-51.2-28.8L271,185.6c51.8,13,72.6,57.6,80.9,93.1C360.5,315.5,357.8,350.2,357.4,355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.1,300.7l-0.6,0l-77.3-0.9l-0.1-0.4c-14.5-71-44.9-115.3-45.2-115.7l-0.9-1.3l90.4,32.3c25.2,28.2,33.5,84.8,33.6,85.4 L427.1,300.7z M350,298.9l76,0.9c-0.9-6-9.6-57.7-33.2-84.2l-87.2-31.2C310.5,192,336.7,234.4,350,298.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.2,266.2c1.2-6,6.3-10.8,12.6-10.8c6.2,0,11.3,4.4,12.5,10.2c0,0-6.1,2.3-10.8,8.6 C295.5,274.1,289.8,267,281.2,266.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.8,
    y: 335.5,
    className: "st0",
    width: 231.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479,356H368.2v-36.6c0-0.1,0-0.3,0-0.6c0-0.4,0-0.9,0-1.6c0-11.9-2-73.4-41.2-113.9 c-23-23.7-54.1-35.8-92.4-35.8c-38.3,0-69.6,12-93,35.7c-43.5,44-43.3,112.5-43.3,116v0.1V356H39.7c3.6,8.4,7.7,16.6,12.2,24.5 h70.9v-61.3c0-2.5,0.4-62.5,36.4-98.9c18.6-18.8,44-28.3,75.4-28.3c31.4,0,56.5,9.5,74.7,28.2c34.2,35.2,34.5,92.1,34.4,98.5 l-0.1,0.3v61.4h121.9c1-1.7,2-3.5,3.1-5.3C472.3,369,476.1,362.6,479,356z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 319.2,
    width: 1.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,503.6c-43.4,0-85.9-11.7-123-33.8c-36-21.4-65.9-52.1-86.5-88.5l-0.1-0.2h419.2l-0.1,0.2 c-20.6,36.5-50.5,67.1-86.5,88.5C345.4,492,302.9,503.6,259.5,503.6 M50.3,381.4c42.7,75.2,122.8,122,209.2,122 c86.4,0,166.5-46.7,209.1-122H50.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.9,
    y: 121,
    width: 1,
    height: 61.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.5,
    y: 333.2,
    className: "st1",
    width: 109.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.6,
    y: 55.7,
    width: 1,
    height: 127.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8,373.3c-8,0-12.4-1.9-16.6-3.7c-3.5-1.5-6.8-3-12-3.2c-0.2,0-0.4,0-0.5,0c-3.4,0-7.5,1.6-11.3,3.1 c-6.4,2.5-12.4,4.9-15.7,0.4c-2.9-4-0.7-8.2,1.9-13.1c2-3.7,4.2-7.9,4.4-12.7c0.2-4.9-2-7.6-4.2-10.3c-2-2.4-4-4.9-4-8.9 c0-2.7,1.6-5.3,3.3-8c1.9-3,4-6.5,4.4-10.8c0.5-5.3-2-8.9-4.3-12.4c-1.9-2.8-3.9-5.8-4.3-9.5c-0.2-1.9,0.6-4.2,1.6-6.8 c1.5-3.9,3.3-8.7,2-14.2c-1-4.1-4.1-5.6-7.7-7.4c-3-1.5-6.5-3.2-9.1-6.7c-2-2.6-1.4-5.2-0.9-8c0.7-3.1,1.4-6.7-1.4-11.2 c-2.4-3.8-5.2-5-8.3-6.2c-2.7-1.1-5.5-2.2-8.1-5.2c-1.2-1.4-1.8-3.4-2.5-5.7c-1.1-3.6-2.3-7.7-6.1-10.7c-3.6-2.9-8.9-3.2-13.5-3.4 c-3.4-0.2-6.7-0.4-8.8-1.6c-2.2-1.2-3.8-3.5-5.5-6c-2.3-3.3-4.9-7-9.5-9.1c-4.7-2.1-11.8-1-18,0c-3.2,0.5-6.3,1-8.8,1 c-4.7,0-8.4-1.8-12-3.6c-4.6-2.3-8.8-4.5-15.3-3.2c-2.8,0.5-5.1,2.5-7.8,4.7c-3.2,2.7-6.9,5.8-12.6,7.6c-2.5,0.8-5.7,0.6-9.1,0.3 c-4.9-0.3-10.5-0.7-15,1.9c-4.9,2.9-6.3,6.4-7.8,10.2c-1.3,3.3-2.7,6.6-6.3,9.8c-4,3.5-8,4.3-11.8,5.1c-3.7,0.7-7.1,1.4-10,4.5 c-4.1,4.4-4.2,8.6-4.2,13c0,3.7-0.1,7.6-2.6,11.6c-2.3,3.7-4.6,5.6-6.6,7.3c-2.7,2.3-5,4.3-6.6,10c-1,3.6-0.2,6.3,0.7,9.5 c0.9,3.1,1.9,6.6,1.2,11.5c-0.7,5.1-3.1,8-5.3,10.8c-2.1,2.5-4,4.9-4.7,8.9c-0.9,5.4,1.2,8.5,3.4,11.7c2.2,3.3,4.5,6.6,3.8,12.4 c-0.5,3.9-1.9,6.1-3.3,8.2c-2.4,3.6-4.7,7-1.2,19.1c2.8,9.9,0.4,14.1-2.1,15.9c-3.9,2.7-10.1,1.2-14.1-1.8 c-11.5-8.4-21.2-4.7-31.4-0.8c-0.7,0.3-1.5,0.6-2.2,0.9c-10.9,4.1-19.7-0.7-19.8-0.7l0.3-0.6c0.1,0,8.6,4.7,19.2,0.7 c0.7-0.3,1.5-0.6,2.2-0.9c9.9-3.8,20.2-7.7,32,0.9c3.8,2.7,9.7,4.3,13.3,1.8c2.3-1.6,4.6-5.6,1.9-15.2c-3.5-12.4-1.2-15.9,1.3-19.7 c1.4-2,2.8-4.1,3.2-7.9c0.7-5.6-1.6-8.8-3.7-12c-2.2-3.2-4.5-6.6-3.6-12.2c0.7-4.1,2.8-6.7,4.8-9.2c2.2-2.7,4.5-5.5,5.2-10.4 c0.7-4.7-0.2-8-1.1-11.2c-0.9-3.1-1.7-6.1-0.7-9.9c1.6-5.9,4-8,6.8-10.3c2-1.7,4.2-3.5,6.4-7.1c2.4-3.9,2.5-7.6,2.5-11.3 c0-4.4,0.1-8.9,4.4-13.5c3.1-3.2,6.6-3.9,10.4-4.7c3.8-0.7,7.7-1.5,11.5-4.9c3.5-3.1,4.8-6.4,6.1-9.6c1.6-3.9,3-7.6,8.1-10.5 c4.7-2.8,10.4-2.4,15.4-2c3.3,0.2,6.4,0.4,8.8-0.3c5.6-1.7,9.2-4.8,12.4-7.4c2.8-2.3,5.1-4.3,8.1-4.9c6.7-1.3,11.3,1,15.7,3.3 c3.5,1.8,7.1,3.6,11.7,3.6c2.4,0,5.5-0.5,8.7-1c6.3-1,13.4-2.1,18.3,0.1c4.8,2.1,7.5,6,9.8,9.3c1.7,2.5,3.2,4.6,5.3,5.8 c2,1.1,5.2,1.3,8.5,1.5c4.7,0.3,10,0.6,13.8,3.6c4,3.1,5.3,7.5,6.4,11c0.7,2.2,1.3,4.2,2.3,5.4c2.5,2.9,5.2,4,7.8,5 c3.1,1.2,6.1,2.4,8.6,6.4c3,4.8,2.2,8.5,1.5,11.7c-0.6,2.7-1,5,0.8,7.4c2.5,3.4,5.9,5,8.9,6.5c3.6,1.8,7,3.4,8.1,7.8 c1.3,5.6-0.6,10.6-2,14.5c-1,2.5-1.8,4.8-1.6,6.5c0.4,3.5,2.2,6.3,4.2,9.2c2.5,3.6,5,7.4,4.5,12.9c-0.4,4.4-2.6,7.9-4.5,11 c-1.7,2.8-3.2,5.2-3.2,7.7c0,3.8,1.9,6.1,3.9,8.5c2.3,2.7,4.6,5.6,4.3,10.7c-0.2,4.9-2.5,9.2-4.5,13c-2.5,4.7-4.6,8.7-2,12.4 c3,4.1,8.8,1.8,14.9-0.6c4.2-1.6,8.4-3.4,12.1-3.2c5.3,0.3,8.7,1.7,12.2,3.3c4.6,2,9.4,4.1,19.2,3.6c4.7-0.4,8.1-2.2,11.3-3.9 c3.9-2,7.9-4.2,14.2-3.9c7.1,0.3,12,2.1,16.2,3.7c5.6,2.1,10.1,3.8,17.4,0.4l0.3,0.6c-7.5,3.5-12.1,1.8-17.9-0.4 c-4.2-1.6-9-3.4-16-3.7c-6.1-0.2-9.9,1.7-13.9,3.8c-3.3,1.7-6.7,3.5-11.6,4C410.7,373.3,409.7,373.3,408.8,373.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.7,372.7c0-1.2-4.3-2.2-9.6-2.2c-5.3,0-9.6,1-9.6,2.2c0,1.2,4.3,2.2,9.6,2.2 C443.4,374.8,447.7,373.9,447.7,372.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.7,372.7c0-1.2-4.3-2.2-9.6-2.2c-5.3,0-9.6,1-9.6,2.2c0,1.2,4.3,2.2,9.6,2.2 C386.4,374.8,390.7,373.9,390.7,372.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.4,334.8c-1.2-0.1-2.5,4.1-2.9,9.4c-0.4,5.3,0.2,9.6,1.4,9.7c1.2,0.1,2.5-4.1,2.9-9.4 C352.3,339.2,351.6,334.8,350.4,334.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.3,314.7c-1.2-0.1-2.5,4.1-2.9,9.4c-0.4,5.2,0.2,9.6,1.4,9.7c1.2,0.1,2.5-4.1,2.9-9.4 C364.1,319.1,363.5,314.8,362.3,314.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.9,295.5c-1.2,0-1.9,4.4-1.7,9.7c0.3,5.3,1.5,9.5,2.7,9.4c1.2,0,1.9-4.4,1.7-9.7 C350.3,299.7,349.1,295.4,347.9,295.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.2,259.1c-1.2,0.2-1.5,4.6-0.6,9.8c0.9,5.2,2.5,9.3,3.7,9.1c1.2-0.2,1.4-4.6,0.6-9.8 C346,262.9,344.3,258.9,343.2,259.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.9,273.1c-1.2,0.1-1.8,4.4-1.3,9.7c0.5,5.3,1.8,9.5,3,9.4c1.2-0.1,1.8-4.5,1.3-9.7 C361.4,277.2,360.1,273,358.9,273.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.1,225.7c-1.1,0.6,0,4.8,2.4,9.6c2.4,4.7,5.2,8.1,6.2,7.5c1.1-0.5,0-4.8-2.4-9.5 C326.9,228.6,324.1,225.2,323.1,225.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.2,235.8c-1.1,0.5,0,4.8,2.4,9.5c2.4,4.7,5.2,8.1,6.3,7.5c1-0.5,0-4.8-2.4-9.5 C346.1,238.6,343.3,235.2,342.2,235.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.8,201.4c-0.9,0.8,1.5,4.6,5.2,8.3c3.7,3.8,7.4,6.2,8.2,5.3c0.9-0.8-1.4-4.6-5.1-8.4 C303.4,202.9,299.6,200.6,298.8,201.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.9,206.9c-0.9,0.8,1.4,4.6,5.1,8.4c3.7,3.8,7.4,6.1,8.3,5.3c0.9-0.9-1.5-4.6-5.2-8.4 C323.4,208.4,319.7,206,318.9,206.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.7,185.6c-0.4,1.1,3.2,3.5,8.2,5.4c4.9,1.9,9.3,2.5,9.7,1.4c0.4-1.1-3.2-3.5-8.2-5.4 C264.5,185.1,260.1,184.5,259.7,185.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.5,184.9c-0.5,1.1,2.9,3.8,7.7,6.1c4.8,2.3,9,3.3,9.6,2.2c0.5-1.1-2.9-3.8-7.7-6.1 C290.3,184.8,286,183.8,285.5,184.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213,183.5c0.1,1.2,4.3,2,9.6,1.8c5.2-0.2,9.5-1.3,9.5-2.5c0-1.2-4.4-2-9.6-1.9 C217.2,181.1,213,182.3,213,183.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.6,181.7c0.3,1.1,4.7,0.9,9.8-0.6c5.1-1.5,8.9-3.6,8.6-4.8c-0.3-1.1-4.8-0.9-9.8,0.6 C189.1,178.4,185.3,180.5,185.6,181.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.7,174c-0.1,1.2,4.1,2.6,9.3,3.1c5.3,0.5,9.6-0.1,9.7-1.2c0.1-1.2-4.1-2.6-9.3-3.1 C241.2,172.2,236.9,172.8,236.7,174"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.1,202.6c0.6,1,4.8-0.3,9.4-2.9c4.5-2.7,7.8-5.7,7.2-6.7c-0.6-1-4.8,0.3-9.4,3 C172.8,198.5,169.5,201.5,170.1,202.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.1,209.4c0.7,0.9,4.6-1.1,8.7-4.6c4-3.4,6.6-7,5.9-7.9c-0.8-0.9-4.7,1.1-8.7,4.5 C147.9,205,145.3,208.5,146.1,209.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.7,234.3c0.9,0.8,4.4-1.9,7.7-6c3.3-4.1,5.3-8,4.4-8.8c-0.9-0.8-4.4,1.9-7.7,6 C138.7,229.7,136.8,233.6,137.7,234.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.9,247.4c1.1,0.6,3.9-2.8,6.3-7.5c2.4-4.7,3.5-9,2.5-9.6c-1.1-0.5-3.9,2.8-6.3,7.5 C118.9,242.5,117.8,246.8,118.9,247.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.6,270.8c1.1,0.4,3.4-3.4,5-8.5c1.6-5,2-9.4,0.9-9.8c-1.1-0.4-3.4,3.4-5,8.5 C121.9,266.1,121.5,270.5,122.6,270.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.5,292.1c1.2,0.2,2.8-3.9,3.7-9.1c0.8-5.2,0.6-9.6-0.6-9.8c-1.2-0.2-2.9,3.9-3.7,9.1 C107.1,287.6,107.3,292,108.5,292.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.2,336.1c1.2,0,2.2-4.3,2.3-9.5c0.1-5.3-0.8-9.6-2-9.6c-1.2,0-2.2,4.2-2.4,9.5 C105.1,331.8,106,336.1,107.2,336.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.2,366.9c1.1,0.7,3.1-0.4,4.5-2.5c1.4-2.1,1.7-4.4,0.6-5.1c-1.1-0.7-3.1,0.4-4.5,2.5 C102.4,363.9,102.1,366.2,103.2,366.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.6,366.2c1.2-0.6,1.1-2.9-0.1-5.1c-1.2-2.2-3.1-3.5-4.3-2.9c-1.1,0.6-1.1,2.9,0.2,5.1 C359.6,365.5,361.5,366.8,362.6,366.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.8,371.1c-0.1,1.2,4.2,2.3,9.5,2.3c5.3,0.1,9.6-0.8,9.6-2c0-1.2-4.2-2.3-9.5-2.4 C76.1,369.1,71.8,369.9,71.8,371.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.6,362c0,1.2,4.2,2.2,9.5,2.3c5.3,0.1,9.6-0.8,9.6-2c0-1.2-4.2-2.2-9.5-2.3C47.9,359.9,43.6,360.8,43.6,362 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.5,313.7c1.2,0.1,2.5-4.1,3-9.4c0.5-5.3-0.1-9.7-1.3-9.8c-1.2-0.1-2.6,4.1-3,9.4 C114.8,309.3,115.3,313.6,116.5,313.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.7,355.3c1.2,0,2.2-4.3,2.4-9.5c0.1-5.3-0.7-9.6-1.9-9.7c-1.2,0-2.3,4.3-2.4,9.6 C114.6,351,115.5,355.3,116.7,355.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.6,365.8c0-1.2-4.3-2.2-9.6-2.2c-5.3,0-9.6,1-9.6,2.2c0,1.2,4.3,2.2,9.6,2.2 C413.3,368,417.6,367,417.6,365.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.3,364.4c0-1.2-4.3-2.2-9.6-2.2c-5.3,0-9.6,0.9-9.6,2.2c0,1.2,4.3,2.2,9.6,2.2 C468,366.6,472.3,365.6,472.3,364.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.6,80 352.5,74.6 281.3,76.9 281.2,76 352.6,73.7 352.7,73.7 371.9,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "281.2,94 353.2,92 371.4,94.9 363.6,80.9 353.9,89.3 341,77.8 330.1,90 315.8,79.8 304.3,90  290.8,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "372.7,137 419.4,136.1 432.3,140.2 427,128.4 419.4,133.8 411.2,125.7 403,135.3 393.5,126.6  386.2,135.7 378.6,127.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288,167.8l-0.7-47.7c0,0-0.7-15.2,6.6-15.2c7.2-0.4,7.2,13.4,7.2,13.4v48.6L288,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,168.3l-0.7-48.2c0-0.4-0.4-10.1,3.3-14c1-1.1,2.3-1.6,3.7-1.6c1.5-0.1,2.8,0.4,4,1.5c3.7,3.5,3.7,12,3.7,12.4v49 L287.5,168.3z M294.3,105.4c-0.1,0-0.2,0-0.3,0c-1.2,0-2.2,0.4-3.1,1.3c-3.5,3.6-3.1,13.2-3.1,13.3l0.7,47.2l12.2-0.8v-48.1 c0-0.1,0-8.5-3.4-11.7C296.4,105.8,295.4,105.4,294.3,105.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.1,165.7l-0.7-48.6c0,0-0.7-15.2,6.6-15.2c7.2-0.5,7.2,13.4,7.2,13.4v49.6L311.1,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,166.2l0-0.5l-0.7-48.6c0-0.4-0.4-10.1,3.3-14c1-1.1,2.3-1.6,3.7-1.6c1.5-0.1,2.8,0.4,4,1.4c3.7,3.5,3.8,12,3.8,12.4 v50L310.6,166.2z M317.4,102.3c-0.1,0-0.2,0-0.3,0c-1.2,0-2.2,0.4-3.1,1.3c-3.5,3.6-3.1,13.2-3.1,13.3l0.7,48.1l12.2-0.8v-49.1 c0-0.1,0-8.5-3.4-11.7C319.4,102.7,318.5,102.3,317.4,102.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.9,163.7l0.2-50.4c0,0-0.7-15.2,6.6-15.2c7.3-0.5,7.3,13.3,7.3,13.3l0.2,51.5L331.9,163.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.4,164.2l0.2-50.9c0-0.4-0.4-10.1,3.4-14c1-1.1,2.3-1.6,3.7-1.6c1.5-0.1,2.9,0.4,4,1.5c3.7,3.5,3.8,12,3.8,12.4l0.2,52 L331.4,164.2z M339.1,98.6c-0.1,0-0.2,0-0.3,0c-1.2,0-2.2,0.4-3,1.3c-3.5,3.6-3.1,13.2-3.1,13.3l-0.2,49.9l13.3-0.7l-0.2-51 c0-0.1,0-8.5-3.4-11.7C341.2,99,340.2,98.6,339.1,98.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.9,180.8l-0.4-24.3c0,0-0.4-7.6,3.7-7.6c4-0.2,4,6.7,4,6.7v24.8L374.9,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.9,181.3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4l-0.4-24.3c0-0.2-0.2-4.9,1.8-7.1c0.6-0.7,1.4-1,2.4-1 c0.9,0,1.8,0.3,2.5,0.9c2,1.9,2,6.1,2,6.2v24.8c0,0.3-0.2,0.5-0.5,0.5L374.9,181.3C374.9,181.3,374.9,181.3,374.9,181.3  M378.3,149.4c-0.1,0-0.1,0-0.2,0c-0.7,0-1.2,0.2-1.7,0.7c-1.7,1.8-1.5,6.3-1.5,6.3l0.4,23.8l6.4-0.4v-24.3c0,0,0-3.9-1.7-5.5 C379.5,149.6,379,149.4,378.3,149.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.5,180.1l-0.5-22.8c0,0-0.4-7.1,4.5-7.1c4.9-0.2,4.9,6.2,4.9,6.2v23.2L388.5,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,180.6c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-0.5-22.8c0-0.1-0.2-4.1,1.8-6.3c0.8-0.9,1.9-1.3,3.2-1.3 c1.4-0.1,2.5,0.3,3.4,1.2c2,1.9,2,5.4,2,5.5v23.2c0,0.3-0.2,0.5-0.5,0.5L388.5,180.6C388.5,180.6,388.5,180.6,388.5,180.6  M392.8,150.8c-0.1,0-0.1,0-0.2,0c-1,0-1.9,0.3-2.5,1c-1.7,1.8-1.5,5.5-1.5,5.5l0.5,22.3l8-0.4v-22.7c0,0,0-3.2-1.7-4.8 C394.6,151.1,393.8,150.8,392.8,150.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.6,180.7l-0.5-22.7c0,0-0.5-7.1,4.5-7.1c4.9-0.2,4.9,6.3,4.9,6.3v23.2L404.6,180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,181.2c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-0.5-22.7c0-0.1-0.2-4.1,1.8-6.3c0.8-0.9,1.9-1.3,3.2-1.3 c1.4-0.1,2.5,0.4,3.4,1.2c2,1.9,2,5.4,2,5.5v23.2c0,0.3-0.2,0.5-0.5,0.5L404.6,181.2C404.6,181.2,404.6,181.2,404.6,181.2  M408.8,151.3c-1.1,0-2,0.3-2.7,1c-1.7,1.8-1.5,5.5-1.5,5.6l0.5,22.3l8-0.4v-22.7c0,0,0-3.2-1.7-4.8 C410.6,151.6,409.8,151.3,408.8,151.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.9,349.6h-94.7v-10.1H473L472.9,349.6z M379.2,348.6H472l0-8.2h-92.9V348.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.9,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.4,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.8,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.3,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.8,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.3,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.7,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.2,
    y: 340,
    className: "st1",
    width: 1,
    height: 9.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.1,329.3H376v-9.2h9.1V329.3z M376.6,328.7h7.8v-7.9h-7.8V328.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.6,329.3h-9.2v-9.2h9.2V329.3z M394.1,328.7h7.9v-7.9h-7.9V328.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.9,329.3h-9.2v-9.2h9.2V329.3z M411.4,328.7h7.9v-7.9h-7.9V328.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.2,
    y: 314.6,
    className: "st1",
    width: 61.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.2,
    y: 307.5,
    className: "st1",
    width: 61.9,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.4,262.1c0,13.5-10.9,24.4-24.4,24.4c-13.5,0-24.4-10.9-24.4-24.4c0-13.5,10.9-24.4,24.4-24.4 C246.5,237.7,257.4,248.7,257.4,262.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.1,287c-13.7,0-24.9-11.2-24.9-24.9c0-13.7,11.2-24.9,24.9-24.9c13.7,0,24.9,11.2,24.9,24.9 C257.9,275.8,246.8,287,233.1,287 M233.1,238.2c-13.2,0-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9 c13.2,0,23.9-10.7,23.9-23.9C257,248.9,246.2,238.2,233.1,238.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.7,266l-1-0.2c1.3-6.5,6.8-11.2,13.1-11.2c6.3,0,11.7,4.5,13,10.6l-1,0.2c-1.2-5.7-6.2-9.8-12-9.8 C288,255.6,282.9,260,281.7,266"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.1,266l-1-0.1c1.2-9.9,9.8-17.7,19.7-17.7c10,0,18.5,7.5,19.7,17.5l-1,0.1c-1.1-9.5-9.1-16.6-18.7-16.6 C284.5,249.1,276.3,256.5,275.1,266"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.6,267.1c-1.2-6-6.2-10.8-12.6-10.8c-6.2,0-11.3,4.4-12.5,10.2c0,0,6.1,2.4,10.8,8.6 C170.3,275.1,176.1,267.9,184.6,267.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.1,267c-1.3-6.1-6.2-10.4-12.1-10.4c-5.8,0-10.9,4.1-12,9.8l-1-0.2c1.3-6.1,6.7-10.6,13-10.6 c6.3,0,11.7,4.6,13.1,11.2L184.1,267z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.1,266.2l-1-0.1c1.4-9.9,10.1-17.2,20.1-17c10.1,0.3,18.3,8,19.2,18l-1,0.1c-0.8-9.5-8.7-16.9-18.2-17.1 C162.6,249.8,154.4,256.7,153.1,266.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.8,327.5v-37.3c0,0,0.9-14.8-9-14.8c-11.3,0-9.9,12.7-10,14.8c-0.2,2.7,0,37.3,0,37.3H320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.3,328h-19.9l0-0.5c0-1.4-0.2-34.6,0-37.3c0-0.2,0-0.5,0-0.9c0-2.5-0.1-8.3,3.3-11.7 c1.7-1.8,4.2-2.6,7.2-2.7c2.4,0,4.4,0.8,5.9,2.4c4,4.3,3.6,12.5,3.6,12.9L321.3,328z M302.3,327h18v-36.8c0-0.1,0.4-8.2-3.3-12.2 c-1.3-1.4-3.1-2.1-5.2-2.1h0c-2.8,0-5,0.8-6.5,2.4c-3.1,3.1-3,8.6-3,11c0,0.4,0,0.8,0,1C302.2,292.7,302.3,322.8,302.3,327"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.4,327.5v-37.3c0,0,1.2-15.1-10.2-14.8c-12.9,0-11.2,12.7-11.3,14.8c-0.2,2.7,0,37.3,0,37.3H290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.8,328h-22.5l0-0.5c0-1.4-0.2-34.6,0-37.3c0-0.2,0-0.5,0-0.9c0-2.5-0.1-7.8,3.3-11.3c2-2,4.9-3,8.6-3 c2.9-0.1,5.4,0.9,7.2,2.8c4.1,4.4,3.6,12.2,3.6,12.6L290.8,328z M269.3,327h20.6v-36.8c0-0.1,0.5-7.8-3.3-11.9 c-1.6-1.7-3.8-2.5-6.4-2.5c-3.4,0-6.1,0.9-7.9,2.8c-3.1,3.1-3,8.2-3,10.6c0,0.4,0,0.8,0,1C269.1,292.7,269.3,322.8,269.3,327"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "260.3,327.2 260.3,281 239.3,297.3 239.3,327.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.8,327.7h-21.9v-30.6l21.9-17.1V327.7z M239.8,326.7h20V282l-20,15.6V326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.5,328.7H135.6c-0.3,0-0.5-0.2-0.5-0.5V290c0-0.4-0.8-11.8,5.8-19.1c3.2-3.6,7.7-5.5,13.3-5.7 c9-0.3,14.9,6.4,16.3,8.4c1.7-1.9,8.6-8.6,18-7.7c6.6,0.6,10.8,3.9,12.9,6.1c-1-3.2-1.5-6.5-1.5-9.8c0-18.2,14.8-33.1,33.1-33.1 c18.3,0,33.1,14.8,33.1,33.1c0,3.3-0.5,6.6-1.5,9.7c2.2-2.2,6.3-5.3,12.8-6c9.4-0.9,16.3,5.8,18,7.7c1.5-1.9,7.3-8.7,16.3-8.4 c5.6,0.2,10.1,2.1,13.3,5.7c6.5,7.2,5.8,18.6,5.8,19.1v38.2C330.9,328.5,330.7,328.7,330.5,328.7 M136.1,327.7H330V290 c0-0.1,0.7-11.5-5.5-18.4c-3.1-3.4-7.3-5.2-12.6-5.4c-9.9-0.3-15.8,8.3-15.9,8.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.3-0.1-0.4-0.2 c-0.1-0.1-7.3-8.8-17.6-7.8c-8.8,0.8-13.1,6.5-13.8,7.7c-0.1,0.2-0.4,0.3-0.6,0.2c-0.2-0.1-0.3-0.4-0.2-0.6 c1.5-3.8,2.3-7.8,2.3-11.9c0-17.7-14.4-32.1-32.1-32.1c-17.7,0-32.1,14.4-32.1,32.1c0,4.1,0.8,8.1,2.3,12c0.1,0.2,0,0.3,0,0.5 c-0.2,0.3-0.7,0.3-0.9,0c0-0.1-4.4-6.9-13.9-7.8c-10.3-1-17.5,7.7-17.5,7.8c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2 c-0.1-0.1-5.7-8.4-15.3-8.4c-0.2,0-0.4,0-0.6,0c-5.3,0.2-9.6,2-12.6,5.4c-6.2,6.9-5.5,18.3-5.5,18.4V327.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.3,327.5v-37.3c0,0-0.9-14.8,9-14.8c11.3,0,9.8,12.7,10,14.8c0.2,2.7,0,37.3,0,37.3H145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.7,328h-20v-37.8c0-0.3-0.5-8.6,3.6-12.9c1.5-1.6,3.5-2.4,5.9-2.4h0c3,0,5.4,0.9,7.2,2.6 c3.3,3.4,3.3,8.9,3.3,11.6c0,0.4,0,0.8,0,1c0.2,2.7,0,35.9,0,37.3L164.7,328z M145.8,327h18c0-4.2,0.2-34.3,0-36.7 c0-0.2,0-0.6,0-1.1c0-2.5,0.1-7.8-3-10.9c-1.6-1.6-3.8-2.3-6.5-2.3c-2.1,0-3.8,0.7-5.2,2.1c-3.7,3.9-3.3,12.1-3.3,12.2V327z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.7,327.5v-37.3c0,0-1.2-15.1,10.2-14.8c12.9,0,11.2,12.7,11.4,14.8c0.2,2.7,0,37.3,0,37.3H175.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.6,328.1l-22.6-0.2l0.3-37.7c0-0.3-0.5-8.2,3.6-12.5c1.8-1.9,4.2-2.8,7.2-2.7c3.7,0,6.5,1.1,8.5,3.1 c3.4,3.4,3.3,8.7,3.2,11.2c0,0.4,0,0.8,0,1c0.2,2.7-0.3,35.9-0.3,37.3L197.6,328.1z M176,327l20.6,0.2c0.1-4.2,0.4-34.3,0.3-36.7 c0-0.2,0-0.6,0-1.1c0-2.4,0.1-7.4-2.9-10.5c-1.8-1.9-4.6-2.8-8.1-2.8c-2.5,0-4.6,0.8-6.2,2.4c-3.9,4-3.4,11.7-3.4,11.8L176,327z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "205.8,327.2 205.8,281 226.8,297.3 226.8,327.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.2,327.7h-21.9V280l21.9,17.1V327.7z M206.3,326.7h20v-29.2l-20-15.6V326.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.7,381.3v0.4c0,4.1-11.8,16.6-13.2,18l-0.4,0.4l-0.3-0.5c-1.7-2.3-7-9.3-18.6-3.9 c-11.6,5.4-23.3,4.9-34-1.3c-6-1.2-10.5,0.3-15.8,1.9c-3.6,1.1-7.3,2.3-12,2.8c-5.3,0.6-9.3-1.3-13.2-3.2 c-4.8-2.3-9.4-4.5-15.9-1.6c-16.2,8-35.9,2.1-45.4-0.7l-0.6-0.2c-3.7-1.1-11.5-0.2-20.5,0.9c-12.7,1.5-27,3.2-36.2,0 c-11.1-3.9-33.5,1.2-48.3,4.6c-6,1.4-10.8,2.4-13.6,2.7c-0.4,0-0.7,0-1.1,0c-4,0-8.1-1.9-12-3.8c-5.7-2.8-11.7-5.6-17.8-2.6 c-11.4,5.7-26.5,2.5-33.3-0.9c-4.6-2.3-11.4-1.6-18.6-0.8c-4,0.4-8.1,0.9-12.3,0.9c-11.9,0-27.1-12.3-27.7-12.8l-0.4-0.3h-4.5 c41.3,73,119.6,122.2,209.4,122.2c89.8,0,168.1-49.2,209.4-122.2H465.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.7,398.4c-3.3,0-6.8-1.7-10.6-3.5c-4.3-2.1-8.8-4.2-13.7-4.2c-2.4,0-4.8,0.6-7,1.6 c-3.7,1.8-8.1,2.8-13.1,2.8c-7.2,0-13.8-2-17.2-3.7c-2.6-1.3-5.8-1.9-10-1.9c-3.3,0-6.9,0.4-10.4,0.8c-3.9,0.4-8,0.8-11.9,0.8 c-6,0-16.4-6.4-21.6-9.7h403.6c-1.8,2.7-8.7,9.7-12.3,13.7c-3.1-3.1-6.8-4.7-11-4.7c-2.9,0-6.1,0.8-9.4,2.3 c-4.9,2.3-9.8,3.4-14.6,3.4c-5.6,0-11.1-1.6-16.3-4.6l-0.2-0.1l-0.4-0.1l-0.3-0.1c-1.7-0.3-3.4-0.5-5.1-0.5 c-4.5,0-8.3,1.2-12.4,2.5c-3.5,1.1-7,2.2-11.4,2.7c-0.6,0.1-1.1,0.1-1.6,0.1c-3.6,0-6.6-1.4-9.8-3c-3.2-1.6-6.9-3.3-11.2-3.3 c-2.5,0-5,0.6-7.5,1.7c-5.1,2.5-10.9,3.8-17.5,3.8c-10.1,0-19.8-2.9-25.5-4.6l-0.7-0.2c-1.4-0.4-3.3-0.6-5.7-0.6 c-4.3,0-10,0.7-16.1,1.4c-7.5,0.9-15.2,1.8-22.2,1.8c-5.3,0-9.4-0.5-12.5-1.6c-3-1.1-6.8-1.6-11.5-1.6c-12.1,0-27.4,3.5-38.6,6 c-5.7,1.3-10.6,2.4-13.2,2.6C177.2,398.3,176.9,398.4,176.7,398.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.6,350.7c0,0-2.7-35.3,1.3-36.7c4.1-1.4,4.1,39.4,4.1,39.4L244.6,350.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "151.8,349.8 151.7,354.7 166.3,369.3 171.6,369.2 171.3,364.3 156.7,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.6,349.8 171.6,354.7 157,369.3 151.7,369.2 152,364.3 166.6,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "181.7,349.8 181.6,354.7 196.2,369.3 201.5,369.2 201.2,364.3 186.6,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "201.4,349.8 201.5,354.7 186.9,369.3 181.6,369.2 181.9,364.3 196.5,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "211.5,349.8 211.5,354.7 226.1,369.3 231.4,369.2 231.1,364.3 216.5,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "231.3,349.8 231.4,354.7 216.8,369.3 211.5,369.2 211.8,364.3 226.4,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.4,349.8 241.4,354.7 256,369.3 261.3,369.2 260.9,364.3 246.4,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.2,349.8 261.3,354.7 246.7,369.3 241.4,369.2 241.6,364.3 256.2,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "271.3,349.8 271.3,354.7 285.8,369.3 291.1,369.2 290.8,364.3 276.3,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "291.1,349.8 291.1,354.7 276.6,369.3 271.3,369.2 271.5,364.3 286.1,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "301.2,349.8 301.1,354.7 315.7,369.3 321,369.2 320.7,364.3 306.1,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "321,349.8 321,354.7 306.4,369.3 301.1,369.2 301.4,364.3 316,349.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "135.4,363.5 134.8,362.7 144.2,355.7 324.8,355.7 334.5,362.6 333.9,363.4 324.5,356.7 144.6,356.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "324.8,363.6 144.2,363.6 134.8,356.6 135.4,355.8 144.6,362.6 324.5,362.6 333.9,355.9 334.5,356.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "241.4,369.2 193,441.7 280.5,433.6 277.8,395.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.4,
    y: 407.1,
    transform: "matrix(0.5524 -0.8336 0.8336 0.5524 -242.9344 362.6965)",
    className: "st1",
    width: 77.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.1,
    y: 410.7,
    transform: "matrix(0.5441 -0.839 0.839 0.5441 -243.8223 373.6676)",
    className: "st1",
    width: 71.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.4,
    y: 415,
    transform: "matrix(0.5141 -0.8578 0.8578 0.5141 -244.5901 399.2301)",
    className: "st1",
    width: 63.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 417.9,
    transform: "matrix(0.5295 -0.8483 0.8483 0.5295 -242.9813 398.7448)",
    className: "st1",
    width: 53.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.9,
    y: 420.2,
    transform: "matrix(0.4992 -0.8665 0.8665 0.4992 -241.3536 423.7721)",
    className: "st1",
    width: 44.1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.5,429.1c-44.4,18.1-98.7-2.7-98.7-2.7l15,35.8c5.4-3.6,16.8-3.2,25.8,1.4c13.6,1.3,13.6-7.7,21.8-4.6 c15.3,5.9,22.1,3.2,28.1,0c5.9-3.1,17.6-0.9,17.6-0.9l29.9-51.1C303.8,406.9,296.6,415.5,264.5,429.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.2,406.3c-0.3-0.2-0.7-0.1-0.9,0.1c-0.1,0.1-7.6,8.7-39.1,22c-43.6,17.8-97.7-2.5-98.2-2.7c-0.2-0.1-0.5,0-0.7,0.2 c-0.2,0.2-0.2,0.5-0.1,0.7l15,35.8c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0,0.5-0.1c5.3-3.6,16.6-2.9,25.1,1.4 c0.1,0,0.2,0.1,0.2,0.1c1,0.1,1.9,0.1,2.7,0.1c5.5,0,8.5-1.9,11-3.4c2.5-1.6,4.3-2.7,7.9-1.3c15.4,6,22.3,3.4,28.6,0 c5.6-3,17.1-0.9,17.2-0.8c0.3,0.1,0.5-0.1,0.7-0.3l29.9-51.1C304.6,406.9,304.5,406.5,304.2,406.3z M273.6,457.3 c-2.3-0.4-12.2-1.8-17.6,1.1c-6,3.3-12.7,5.7-27.5,0c-4.2-1.6-6.4-0.2-9.1,1.4c-2.8,1.8-6,3.7-12.7,3.1c-8.7-4.4-19.7-5-25.7-1.7 l-14.1-33.7c8.8,3.1,57.6,18.6,97.8,2.2c21.5-9.1,31.9-15.9,36.5-19.5L273.6,457.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "250.4,433.6 249.5,415.1 250.5,415 251.4,433.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.7,
    y: 412.7,
    transform: "matrix(0.9987 -5.000796e-02 5.000796e-02 0.9987 -20.7832 13.3912)",
    className: "st1",
    width: 1,
    height: 18.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 410,
    transform: "matrix(0.9988 -4.823352e-02 4.823352e-02 0.9988 -19.9159 13.3323)",
    className: "st1",
    width: 1,
    height: 18.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 407.8,
    transform: "matrix(0.999 -4.518754e-02 4.518754e-02 0.999 -18.5422 12.7829)",
    className: "st1",
    width: 1,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.8,
    y: 406.4,
    transform: "matrix(0.9991 -4.258502e-02 4.258502e-02 0.9991 -17.4002 12.2704)",
    className: "st1",
    width: 1,
    height: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.2,418c6.1-17.6,1.7-23.7-10.5-41c-2.9-4.1-6.2-8.7-9.9-14.3c-15.7-23.5-9.8-40.9-6.8-46.9 c-0.9,11.2,8.6,27.3,26,43.9c17.6,16.7,29.2,44.8,31.6,50.8C268.7,406.5,252.7,415.3,248.2,418z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286,414.6c13.3-36.4-11.5-51.7-35.4-66.6c-21.5-13.3-27.4-28.1-28.8-33c-4.7,15.7,3.9,25.5,15.6,38.8 c2.7,3.1,5.6,6.3,8.4,9.9c13.9,17.2,10.9,41.2,10.2,45.8c4.1-1.2,7.8-1.7,11.1-1.7C277.9,407.7,284.2,412.8,286,414.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.4,234.6c0.6-1.3,1-2.8,1-4.4c0-4.5-2.9-8.1-6.5-8.1c-3.6,0-6.5,3.7-6.5,8.1c0,0.9,0.1,1.8,0.3,2.5 c-3.3,0.2-6,3.8-6,8.1c0,4.5,2.8,8.2,6.3,8.2c2.2,0,4.1-1.5,5.2-3.7c0.8,3.2,2.9,5.5,5.5,5.5c3.2,0,5.8-3.6,5.8-8.1 C457.6,238.4,455.3,235,452.4,234.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.8,251.3c-2.4,0-4.5-1.9-5.6-4.7c-1.3,1.9-3.1,3-5.1,3c-3.7,0-6.8-3.9-6.8-8.7c0-4.3,2.5-8,5.9-8.5 c-0.1-0.7-0.2-1.4-0.2-2.1c0-4.7,3.1-8.6,7-8.6c3.8,0,6.9,3.9,6.9,8.6c0,1.4-0.3,2.7-0.8,4c2.9,0.8,5,4.3,5,8.5 C458.1,247.4,455.3,251.3,451.8,251.3 M446.4,244.8C446.4,244.8,446.4,244.8,446.4,244.8c0.3,0,0.4,0.2,0.5,0.4 c0.8,3.1,2.8,5.1,5,5.1c2.9,0,5.3-3.4,5.3-7.6c0-3.9-2.1-7.2-4.8-7.6c-0.2,0-0.3-0.1-0.4-0.3c-0.1-0.1-0.1-0.3,0-0.4 c0.6-1.3,0.9-2.7,0.9-4.2c0-4.2-2.7-7.6-6-7.6c-3.3,0-6,3.4-6,7.6c0,0.8,0.1,1.6,0.3,2.4c0,0.1,0,0.3-0.1,0.4 c-0.1,0.1-0.2,0.2-0.4,0.2c-3.1,0.2-5.5,3.6-5.5,7.6c0,4.2,2.6,7.7,5.8,7.7c1.9,0,3.8-1.3,4.8-3.4 C446,244.9,446.2,244.8,446.4,244.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.6,211.7C466.6,211.7,466.6,211.7,466.6,211.7c-2.6-0.3-3.9-1.6-5.2-3c-1.2-1.2-2.4-2.5-4.9-3.3 c-1.1-0.4-2-0.4-3.1-0.4c-1.4,0-3,0-5.5-0.8c-1.2-0.4-2.1-1.6-3.2-3.1c-1.3-1.7-2.7-3.6-4.7-4.4c-1.3-0.5-2.6-0.5-4.1-0.4 c-1.7,0.1-3.7,0.1-6.3-0.7c-2.1-0.6-3.2-2-4.3-3.4c-1.1-1.4-2.2-2.7-4.3-3.2c-2.2-0.5-4.3,0.4-6.6,1.4c-2,0.9-4.1,1.8-6.4,1.8 c-1.5,0-3-0.9-4.8-1.9c-2.2-1.2-4.6-2.7-7.4-2.6c-2.8,0.1-4.7,1.2-6.6,2.3c-1.8,1-3.6,2.1-5.9,2.2c-1.9,0.1-3.5-0.6-5.2-1.3 c-1.7-0.7-3.4-1.4-5.6-1.4c-2.6,0-4.4,0.9-6.3,1.9c-1.1,0.5-2.2,1.1-3.4,1.5c-2.1,0.6-4.4-0.2-6.8-1.1c-1.6-0.6-3.3-1.2-4.9-1.3 c-3.9-0.3-10.5,1.2-10.5,1.3c-0.3,0.1-0.5-0.1-0.6-0.4c-0.1-0.3,0.1-0.5,0.4-0.6c0.3-0.1,6.7-1.6,10.8-1.3c1.8,0.2,3.5,0.8,5.2,1.4 c2.3,0.8,4.4,1.6,6.2,1c1.2-0.4,2.2-0.9,3.3-1.4c1.9-1,3.8-2,6.7-2c2.4,0,4.3,0.8,6,1.5c1.6,0.7,3.1,1.3,4.8,1.2 c2.1-0.1,3.8-1,5.5-2c2-1.1,4.1-2.3,7.1-2.4c3-0.1,5.6,1.4,7.9,2.7c1.7,0.9,3.1,1.7,4.3,1.7c2.1,0,4.1-0.9,6-1.7 c2.3-1,4.7-2,7.2-1.5c2.5,0.6,3.7,2.1,4.8,3.5c1,1.3,2,2.5,3.8,3c2.5,0.8,4.3,0.7,6,0.7c1.5,0,2.9-0.1,4.5,0.5 c2.3,0.9,3.8,2.9,5.2,4.7c1,1.3,1.8,2.5,2.7,2.7c2.3,0.7,3.9,0.7,5.2,0.7c1.1,0,2.2,0,3.4,0.4c2.7,0.8,4,2.3,5.2,3.5 c1.2,1.3,2.3,2.4,4.5,2.7c0.3,0,0.5,0.3,0.4,0.5C467.1,211.5,466.9,211.7,466.6,211.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.4,252.1c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.4-0.4-0.3-0.6c1.3-3,0.6-14.1-0.7-16.8c-1.5-3.1-1.4-8,0.2-12.2 c2-5,0.3-8.7-1.1-11.6c-3-6.3,1-14.1,1.1-14.5c0.1-0.2,0.4-0.3,0.7-0.2c0.2,0.1,0.3,0.4,0.2,0.7c0,0.1-3.9,7.8-1.1,13.6 c1.5,3.1,3.3,6.9,1.2,12.4c-1.6,3.9-1.7,8.6-0.3,11.4c1.5,3,2.2,14.3,0.8,17.6C418.8,252,418.6,252.1,418.4,252.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,326.1c-0.2,0-0.4-0.2-0.5-0.4c0-0.2-0.7-4.2,0-7.3c0.1-0.5,0.3-1.2,0.5-2c1-4,3.2-12.4,1.9-15.7 c-2.2-5.3-4.5-13-3-19.6c0.3-1.4,0.7-3,1.2-4.6c1.7-6.1,3.9-13.6,0.1-19.6c-2.8-4.3-1.1-14.3,2.1-21.1c3.6-7.7-0.3-15.8-0.3-15.9 c-0.1-0.2,0-0.5,0.2-0.7c0.2-0.1,0.5,0,0.7,0.2c0.2,0.3,4.2,8.7,0.3,16.7c-3.1,6.6-4.7,16.2-2.2,20.1c4,6.3,1.8,14.1,0,20.4 c-0.5,1.6-0.9,3.2-1.2,4.6c-1.4,6.4,0.9,13.9,3,19.1c1.5,3.6-0.7,11.9-1.8,16.3c-0.2,0.8-0.4,1.5-0.5,2c-0.6,2.9,0,6.9,0,6.9 C469.5,325.8,469.4,326,469,326.1C469.1,326.1,469,326.1,469,326.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.7,333.6h-32.6c-0.3,0-0.5-0.2-0.5-0.5l-0.1-130.4c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.1,0.5-0.1 l32.6,12.7c0.2,0.1,0.3,0.3,0.3,0.5l0,117.7c0,0.1-0.1,0.3-0.1,0.3C463,333.5,462.9,333.6,462.7,333.6 M430.7,332.6h31.6l0-116.9 l-31.6-12.3L430.7,332.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "410.1,243 409.5,199.8 349.5,201.2 349.5,200.2 410.5,198.8 411.1,243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "279.4,60.6 353.2,60.6 372.2,70.1 372.2,66.6 355,56 279.9,55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "78.2,353.9 77.2,353.9 77.2,281.5 100.8,281.5 100.8,282.4 78.2,282.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.1,353.9 54.2,353.9 54.2,312.7 77.7,312.7 77.7,313.6 55.1,313.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 295.7,
    className: "st1",
    width: 21,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 323.5,
    className: "st1",
    width: 23.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 304.3,
    className: "st1",
    width: 1,
    height: 49.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 332.8,
    className: "st1",
    width: 1,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 333.8,
    className: "st1",
    width: 67.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.3,169.2 281.2,168.3 351.9,162.8 352,162.8 371.6,167.2 371.4,168.2 351.8,163.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,502.6c-132.8,0-240.9-108.1-240.9-240.9c0-132.8,108.1-240.9,240.9-240.9 c132.8,0,240.9,108.1,240.9,240.9C500.4,394.6,392.3,502.6,259.5,502.6 M259.5,21.8c-132.3,0-239.9,107.6-239.9,239.9 c0,132.3,107.6,239.9,239.9,239.9c132.3,0,239.9-107.6,239.9-239.9C499.4,129.5,391.8,21.8,259.5,21.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInsurance);
export default __webpack_public_path__ + "static/media/health-insurance.65e383c3b912bb83f7021a4012a4d00c.svg";
export { ForwardRef as ReactComponent };